/**
 * isRecordValue
 *
 * Narrows to a non-null, non-array object: the shared precondition of every
 * shape check in the derive engine — `isTimestampShaped`, the reference and
 * manual-entry arms of `canonicalizeFormDeriveValue`, and the recursive object
 * comparison in `formDeriveValuesMatch`. Class instances pass on purpose:
 * an SDK Timestamp arrives as an instance, never as a plain object.
 */

function isRecordValue(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export { isRecordValue };
